/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FileUploadDto } from './FileUploadDto';
import {
    FileUploadDtoFromJSON,
    FileUploadDtoFromJSONTyped,
    FileUploadDtoToJSON,
} from './FileUploadDto';

/**
 * 
 * @export
 * @interface DiplomeCertificationFichierUploadDto
 */
export interface DiplomeCertificationFichierUploadDto {
    /**
     * 
     * @type {FileUploadDto}
     * @memberof DiplomeCertificationFichierUploadDto
     */
    file?: FileUploadDto;
    /**
     * 
     * @type {number}
     * @memberof DiplomeCertificationFichierUploadDto
     */
    iddiplomeCertificationFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof DiplomeCertificationFichierUploadDto
     */
    iddiplomeCertification?: number;
    /**
     * 
     * @type {number}
     * @memberof DiplomeCertificationFichierUploadDto
     */
    idfichier?: number;
    /**
     * 
     * @type {number}
     * @memberof DiplomeCertificationFichierUploadDto
     */
    idtypeAcquisFichier?: number;
    /**
     * 
     * @type {string}
     * @memberof DiplomeCertificationFichierUploadDto
     */
    fileName?: string | null;
}

/**
 * Check if a given object implements the DiplomeCertificationFichierUploadDto interface.
 */
export function instanceOfDiplomeCertificationFichierUploadDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DiplomeCertificationFichierUploadDtoFromJSON(json: any): DiplomeCertificationFichierUploadDto {
    return DiplomeCertificationFichierUploadDtoFromJSONTyped(json, false);
}

export function DiplomeCertificationFichierUploadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiplomeCertificationFichierUploadDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'file': !exists(json, 'file') ? undefined : FileUploadDtoFromJSON(json['file']),
        'iddiplomeCertificationFichier': !exists(json, 'iddiplomeCertificationFichier') ? undefined : json['iddiplomeCertificationFichier'],
        'iddiplomeCertification': !exists(json, 'iddiplomeCertification') ? undefined : json['iddiplomeCertification'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'idtypeAcquisFichier': !exists(json, 'idtypeAcquisFichier') ? undefined : json['idtypeAcquisFichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
    };
}

export function DiplomeCertificationFichierUploadDtoToJSON(value?: DiplomeCertificationFichierUploadDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file': FileUploadDtoToJSON(value.file),
        'iddiplomeCertificationFichier': value.iddiplomeCertificationFichier,
        'iddiplomeCertification': value.iddiplomeCertification,
        'idfichier': value.idfichier,
        'idtypeAcquisFichier': value.idtypeAcquisFichier,
        'fileName': value.fileName,
    };
}

